import { Component, ElementRef, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {Config} from '../config';
import {NgStyle} from '@angular/common';
import {Jsonp, Http, Headers, URLSearchParams, Response, RequestOptions } from '@angular/http';

// import { EventsService } from '../Events.service';
// import {ElectionService} from '../election-service/election.service';
// import { SettingsService } from '../settings/settings.service';

// import {TranslatePipe, TranslateService} from 'ng2-translate/ng2-translate';

declare let componentHandler: any;

@Component({
    selector: 'email-panel',
    template: require('./email.component.html')
})

export class EmailComponent implements OnInit  {
 
    @Input() emailSubject:string;
    @Input() emailBody:string;
    @Output() displayStatus = new EventEmitter<boolean>();


    //General state/admin variables
    error: any;
    appSettings: Object;

    //email
    toAddress:string;
    fromAddress:string; 
    message:Object;
    isDisplayed:boolean = false;

    private jsonpCallback:string = "?method=JSONP_CALLBACK";

    //  inject necessary services
    constructor(private elRef: ElementRef, private http: Http) { 
       
    }

    //initialize email objects 
    ngOnInit () {
        this.appSettings = Config.config[0];
        //update chnages in the DOM
        componentHandler.upgradeAllRegistered();

        //get email inputs
        let fromInput: any = document.getElementById('fromemail');
        let toInput:any = document.getElementById('toemail');

        // //if there is an address in local storage
        this.fromAddress = window.localStorage.getItem("planIndyFromEmail" );
        this.fromAddress ? toInput.focus() : fromInput.focus();

        //update chnages in the DOM
        componentHandler.upgradeAllRegistered();
        
        //set necessary styles
        fromInput ? fromInput.parentElement.classList.add('is-dirty'): console.log("from email input is undefined");
        fromInput ? fromInput.parentElement.classList.remove('is-invalid'): console.log("from email input is undefined");
    }



    // destroy 
    ngOnDestroy() {

    }
    
    //emit the event telling the parent component to show the panel
    showPanel() {
        //this.isDisplayed = true;
        this.displayStatus.emit(true)
        
    }

    
    //emit the event telling the parent component to hide the panel
    closePanel() {
       this.displayStatus.emit(false)
    }

    //trigger the send email
    sendEmail() {
        //create the message object to send to the service
        this.message = JSON.stringify({ 
            "toAddress": this.toAddress,
            "fromAddress": this.fromAddress,
            "subject": this.emailSubject,
            "body": this.emailBody 
        });

        ///The proxy.ashx does not work on the node, needs to be on IIS
        let urlEndpoint:string = this.appSettings["EmailService"]["url"] + this.jsonpCallback;
 

        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        this.http.post(urlEndpoint, this.message, options)
                        .toPromise()
                        .then(response => {
                            var responseObj:any = response.json();
                        })
                        .catch(error => {
                            console.log(error);
                        });
        
        window.localStorage.setItem("planIndyFromEmail",this.fromAddress );
        // window.localStorage.setItem("planIndyToEmail",this.toAddress );
        
        //close the dialog
        this.displayStatus.emit(false)
    }


}


// WEBPACK FOOTER //
// ./app/tools/email.component.ts